import { Tabs, Tooltip } from '@mantine/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ClaimTabItem } from '../../../types/tabs'
import classes from './ClaimTabs.module.css'
export type { ClaimTabItem } from '../../../types/tabs'

export interface ClaimTabsProps {
  value: string
  tabs?: ClaimTabItem[]
  onTabChange: (value: string | null) => void
}

export function ClaimTabs({ tabs = [], value, onTabChange }: Readonly<ClaimTabsProps>) {
  const hasMatchingTab = tabs.some((tab) => tab.value === value)
  const resolvedValue = hasMatchingTab ? value : (tabs[0]?.value ?? null)

  return (
    <Tabs
      value={resolvedValue}
      onChange={(tab) => {
        if (tab) onTabChange(tab)
      }}
      keepMounted={false}
      variant="unstyled"
      classNames={classes}
    >
      <Tabs.List grow>
        {tabs.map((tab) => {
          if (!tab.icon) return null
          return (
            <Tooltip key={tab.value} label={tab.label} className={classes.tooltip}>
              <Tabs.Tab value={tab.value} disabled={tab.disabled} leftSection={<FontAwesomeIcon icon={tab.icon} />}>
                {tab.label}
              </Tabs.Tab>
            </Tooltip>
          )
        })}
      </Tabs.List>

      {tabs.map((tab) =>
        tab.panel ? (
          <Tabs.Panel key={tab.value} value={tab.value}>
            {tab.panel}
          </Tabs.Panel>
        ) : null
      )}
    </Tabs>
  )
}
